import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var SvgNetwork = function SvgNetwork(_a) {
  var _b = _a,
      size = _b.size,
      _b$title = _b.title,
      title = _b$title === void 0 ? "Network" : _b$title,
      props = __objRest(_b, ["size", "title"]);

  return (
    /* @__PURE__ */
    React.createElement("svg", __spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      width: size,
      height: size,
      "data-icon-name": title,
      "aria-label": title,
      role: "presentation"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#142739",
      d: "M30.367 24.097L19.53 18l10.838-6.097a.75.75 0 00-.735-1.306L18.75 16.718V4.5a.75.75 0 10-1.5 0v12.218L6.368 10.597a.75.75 0 00-.735 1.306L16.47 18 5.633 24.097a.75.75 0 00.734 1.306l10.883-6.121V31.5a.75.75 0 101.5 0V19.282l10.883 6.121a.75.75 0 00.736-1.306h-.002z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#32CBCB",
      d: "M30 15a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#142739",
      d: "M30 25.5a.75.75 0 01-.75-.75v-13.5a.75.75 0 111.5 0v13.5a.75.75 0 01-.75.75z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#435261",
      d: "M30 28.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#142739",
      d: "M18 32.25a.75.75 0 01-.368-1.403l12-6.75a.75.75 0 01.735 1.306l-12 6.75a.74.74 0 01-.367.097z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#32CBCB",
      d: "M18 35.25a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#435261",
      d: "M18 21.75a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#142739",
      d: "M18 32.25a.74.74 0 01-.367-.097l-12-6.75a.75.75 0 01.735-1.306l12 6.75A.75.75 0 0118 32.25z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#435261",
      d: "M6 28.5A3.75 3.75 0 106 21a3.75 3.75 0 000 7.5z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#142739",
      d: "M6 25.5a.75.75 0 01-.75-.75v-13.5a.75.75 0 111.5 0v13.5a.75.75 0 01-.75.75z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#2DB6B6",
      d: "M6 15a3.75 3.75 0 100-7.5A3.75 3.75 0 006 15z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#142739",
      d: "M6 12a.75.75 0 01-.368-1.403l12-6.75a.75.75 0 11.735 1.306l-12 6.75A.74.74 0 016 12z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#435261",
      d: "M18 8.25a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fill: "#142739",
      d: "M27.18 8.803l-8.813-4.956a.75.75 0 00-.735 1.306l8.813 4.958a3.72 3.72 0 01.734-1.308z"
    }))
  );
};

var Network = withIcon(SvgNetwork);
export { Network as default };